import { render, staticRenderFns } from "./Sidebar-menu.vue?vue&type=template&id=3f5c5acf&scoped=true&"
import script from "./Sidebar-menu.vue?vue&type=script&lang=js&"
export * from "./Sidebar-menu.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar-menu.vue?vue&type=style&index=0&id=3f5c5acf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5c5acf",
  null
  
)

export default component.exports